import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { FEATURE_CHECKOUT_STORE_CREDIT } from 'constants/features';
/**
 *
 * Returns false for 6pm marketplace regardless of feature flag enrollment
 */
export const useStoreCreditEnabled = () => {
  const { isEnrolled: isStoreCreditFeatureEnabled } = useIsEnrolledInVariant({ featureFlag: FEATURE_CHECKOUT_STORE_CREDIT });

  return { isStoreCreditEnabled: isStoreCreditFeatureEnabled };
};
